import { render, staticRenderFns } from "./general-details-card.vue?vue&type=template&id=2a8e5387"
import script from "./general-details-card.vue?vue&type=script&lang=js"
export * from "./general-details-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports